import React from 'react'

import { Field } from 'formik'

import { ZariContext } from '_zari/context'

import { Form, Col, Row } from '_zari/core'

import * as TablasPersonalizadasService from 'services/tablasPersonalizadas.service'

import { TiposTablaPersonalizadaConstant } from 'constants/index'

const ROLES_OFICINA = [
  { value: 'JEFE', label: 'Jefe' },
  { value: 'PERSONAL', label: 'Personal' }
]

const OficinasTab = ({ oficinasSeleccionados }) => {
  const __zariContext = React.useContext(ZariContext)
  const [oficinas, setOficinas] = React.useState([])

  React.useEffect(() => {
    TablasPersonalizadasService.getAsSelect(TiposTablaPersonalizadaConstant.OFICINA)
      .then(({ data }) => setOficinas(data))
      .catch(({ data: { error } }) => __zariContext.snack('error', error))
  }, [__zariContext])

  const getOficinaData = id => {
    return oficinasSeleccionados.find(x => x._idOficina === id)
  }

  return (
    <Field name='oficinas'>
      {({ field, form }) => (
        <Row>
          <Col md={3} />
          <Col md={9}>
            {oficinas.map(x => {
              const asignada = getOficinaData(x._id)
              return (
                <Row key={x._id} className='mb-2 align-items-center'>
                  <Col md={1}>
                    <Form.Checkbox
                      id={`check-oficina-${x._id}`}
                      label=''
                      checked={!!asignada}
                      onChange={e => {
                        const current = field.value || []
                        if (e.target.checked) {
                          form.setFieldValue('oficinas', [...current, { _idOficina: x._id, rol: 'PERSONAL' }])
                        } else {
                          form.setFieldValue(
                            'oficinas',
                            current.filter(o => o._idOficina !== x._id)
                          )
                        }
                      }}
                    />
                  </Col>
                  <Col md={6}>{x.nombre}</Col>
                  <Col md={4}>
                    {asignada && (
                      <select
                        className='form-control form-control-sm'
                        value={asignada.rol}
                        onChange={e => {
                          const current = field.value || []
                          form.setFieldValue(
                            'oficinas',
                            current.map(o => (o._idOficina === x._id ? { ...o, rol: e.target.value } : o))
                          )
                        }}
                      >
                        {ROLES_OFICINA.map(r => (
                          <option key={r.value} value={r.value}>
                            {r.label}
                          </option>
                        ))}
                      </select>
                    )}
                  </Col>
                </Row>
              )
            })}
          </Col>
        </Row>
      )}
    </Field>
  )
}

export default React.memo(OficinasTab)
